import React from 'react';
import { motion } from 'framer-motion';
export function OpeningHook() {
  return <section className="py-20 px-6 bg-dark-lighter relative" data-id="element-116">
      <div className="max-w-3xl mx-auto text-center" data-id="element-117">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8
      }} viewport={{
        once: true,
        margin: '-100px'
      }} data-id="element-118">
          <p className="font-serif text-2xl md:text-3xl leading-relaxed text-cream italic" data-id="element-119">
            "Lo has visto en cada video de TikTok e Instagram. Ese sonido
            crujiente al morderlo, el relleno verde esmeralda desbordante y esa
            capa de chocolate perfectamente brillante."
          </p>
          <div className="mt-8 space-y-6 font-sans text-lg text-cream-muted" data-id="element-120">
            <p data-id="element-121">
              Es el{' '}
              <strong className="text-gold font-semibold" data-id="element-122">
                "Dubai Chocolate Cake"
              </strong>
              , y conseguir uno puede costar hasta $100... si es que logras
              encontrarlo disponible.
            </p>
            <p data-id="element-123">
              Pero, ¿sabías que el secreto de su lujo no está en ingredientes
              imposibles, sino en una{' '}
              <span className="text-cream font-medium" data-id="element-124">
                técnica específica de texturas
              </span>{' '}
              que puedes replicar hoy mismo en tu casa?
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}